// extracted by mini-css-extract-plugin
module.exports = {"label":"FloatInputLabel_label__cL9fN","text":"FloatInputLabel_text__3tRJv","textFloat":"FloatInputLabel_textFloat__29MTu","small":"FloatInputLabel_small__3Z29B"};